var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.866 31.5C19.4811 32.1667 18.5189 32.1667 18.134 31.5L0.813466 1.50001C0.428563 0.833339 0.909688 3.50481e-06 1.67949 3.43751e-06L36.3205 4.09094e-07C37.0903 3.41796e-07 37.5714 0.833332 37.1865 1.5L19.866 31.5Z",
    fill: "#FC9D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonOrange);
export default __webpack_public_path__ + "static/media/PolygonOrange.391c93e7.svg";
export { ForwardRef as ReactComponent };